import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import '../Customers/CustomersStyle.css';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faSave, faFileImport } from '@fortawesome/free-solid-svg-icons';
import AddProduct from './AddProduct';
import ImportProducts from './ImportProducts';
import EditIcon from '../../Images/ic_edit.svg';
import DeleteIcon from '../../Images/ic_delete.svg';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Regions from '../Common/Region';

const Products = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [productsData, setproductsData] = useState([]);
    const [allProductsData, setAllproductsData] = useState([]);
    const [productEditData, setproductEditData] = useState([]);
    const [displayAddProduct, setdisplayAddProduct] = useState("none");
    const [displayImportProduct, setdisplayImportProduct] = useState("none");
    const [IsEdit, setIsEdit] = useState(0);
    const [FilterProduct, setFilterProduct] = useState([]);
    //const [IsDeletedProducts, setIsDeletedProducts] = useState(false);
    const [RegionSymbol, setRegionSymbol] = useState({});

    useEffect(() => {
        FetchProducts();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const ProductsDataSuccess = (data) => {
        let activeData = data.filter(p => p.IsDeleted === 0);
        setproductsData(activeData);
        setFilterProduct(activeData);
        setAllproductsData(data);
    };

    const showProduct = () => {
        setdisplayAddProduct("block");
        setIsEdit(0);
    };

    const hideProduct = () => {
        setdisplayAddProduct("none");
    };

    const EditSelectedProduct = (productDetails) => {
        setproductEditData(productDetails);
        setIsEdit(1);
        setdisplayAddProduct("block");
    };

    const DeleteSelectedProduct = (ProductID) => {
        Axiosfetch(baseURL + "DeleteProduct", "POST", { ID: ProductID }, ProductSuccess, Failure);
    };

    const ActivateSelectedProduct = (ProductID) => {
        Axiosfetch(baseURL + "ActivateProduct", "POST", { ID: ProductID }, ProductSuccess, Failure);

    };

    const onProductSearch = (e) => {
        let searchValue = e.target.value;
        if (searchValue !== "") {
            let productSearchData = productsData.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterProduct(productSearchData);
        }
        else {
            setFilterProduct(productsData);
        }
    };

    const ProductSuccess = (data) => {
        FetchProducts();
        //setIsDeletedProducts(false);
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const FetchProducts = () => {
        Axiosfetch(baseURL + "GetAllProducts", "GET", null, ProductsDataSuccess, Failure);
    };

    // const OnCheckedChange = (e) => {
    //     setIsDeletedProducts(e.target.checked);
    //     if (e.target.checked) {

    //         let DeletedProducts = allProductsData.filter(p => p.IsDeleted === 1);
    //         setFilterProduct(DeletedProducts);
    //     }
    //     else {
    //         let ActiveProducts = allProductsData.filter(p => p.IsDeleted === 0);
    //         setFilterProduct(ActiveProducts);
    //     }
    // };

    const SaveImportProductDetails = (Importedproducts) => {
        Axiosfetch(baseURL + "ImportProduct", "POST", Importedproducts, ProductImportSuccess, Failure);
    };

    const ProductImportSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        hideImportproduct();
        FetchProducts();
    };

    const hideImportproduct = () => {
        setdisplayImportProduct("none");
    };

    const showImportproduct = () => {
        setdisplayImportProduct("block");
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    {/* <div className="col-md-2 col-sm-3 align-center" style={{ margin: "auto" }}>
                        <span><input style={{ marginRight: "4px" }} type="checkbox" checked={IsDeletedProducts} onChange={e => OnCheckedChange(e)}></input>Deleted Product</span>
                    </div> */}
                    <div className="offset-md-2 col-md-4 col-sm-4">
                        <h5 className="align-right" style={{ fontWeight: "500" }}>Products</h5>
                    </div>
                    <div className="offset-md-1 col-md-3 col-sm-3" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search Product..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onProductSearch(e)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-3 align-center">
                        <span style={{ paddingRight: "20px" }} data-tip="Import Product" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showImportproduct}>
                            <FontAwesomeIcon icon={faFileImport} />
                        </span>
                        <span data-tip="Add Product" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showProduct}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>

                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div className="col-md-12 tableQuotationRecordsStyle" style={{ scrollbarColor: "#005582 transparent" }}>
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Active</th>
                                    <th style={{ width: "250px" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}> Name</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}> Description</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}> Price</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}> Units</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"} (%)</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}> HSN Code</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}> Margin (%)</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}> Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    FilterProduct.length > 0 && FilterProduct.map(product => (
                                        <tr key={product.ID} className="textCenter">
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><div className={product.IsDeleted ? "InActiveDiv" : "ActiveDiv"}></div></td>
                                            <td>{product.Name}</td>
                                            <td className="tdtableCustomersAddressTDStyle">{product.Description}</td>
                                            <td>{product.Price}</td>
                                            <td>{product.Units}</td>
                                            <td>{product.Gst}</td>
                                            <td>{product.HSNCode === "" || product.HSNCode === null ? "-" : product.HSNCode}</td>
                                            <td>{product.Margin}</td>
                                            <td style={{ minWidth: "100px" }}>
                                                {product.IsDeleted === 0 && <img title="Edit" className="cursorpointer" src={EditIcon} alt="Edit" onClick={(productDetails) => EditSelectedProduct(product)}></img>}
                                                {product.IsDeleted === 0 && <img title="Delete" className="cursorpointer" onClick={(customerID) => DeleteSelectedProduct(product.ID)} style={{ marginLeft: 15 }} src={DeleteIcon} alt="Delete"></img>}
                                                {product.IsDeleted === 1 && <span title="Activate" className="cursorpointer" onClick={(customerID) => ActivateSelectedProduct(product.ID)} style={{ marginLeft: 15 }}><FontAwesomeIcon style={{ fontSize: "1.4rem" }} icon={faSave} /></span>}
                                            </td>
                                        </tr>
                                    ))
                                }
                                {
                                    FilterProduct.length === 0 && (<tr className="textCenter">
                                        <td colSpan="9">
                                            There are no Products
                                        </td>
                                    </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {displayImportProduct === "block" && <ImportProducts SaveImportProductDetails={SaveImportProductDetails} hideImportproduct={hideImportproduct} regionDetails={RegionSymbol}></ImportProducts>}
                {displayAddProduct === "block" && <AddProduct themecolor={CurrentTheme} hideproduct={hideProduct} getProduct={FetchProducts} regionDetails={RegionSymbol} edit={IsEdit} productdetail={productEditData} allProduct={allProductsData}></AddProduct>}
            </div>
        </div>
    );
};

export default Products;